/**
 * helper.ts
 * 函数可以存在副作用(DOM操作、网络请求、UI变化等)
 */

import {toast} from 'acud';
import monitor from '@baidu/fe-monitor';
import {getQuery, isMultiLogin, getRedirectUrl, getLoginType, getSearch, getQueryVariable} from './util';
import {Channel, LoginType} from './constants';

// baidubce/13C1chLrH@infxx
export function useBaiduTongji() {
    const hm = document.createElement('script');
    hm.src = 'https://hm.baidu.com/hm.js?28a17f66627d87f1d046eae152a1c93d';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(hm, s);
}

export function useLbsyun() {
    if (!isMultiLogin() && getQuery('lbsyun') === '1') {
        $('#login .login-action .other').hide();
        $('.page-wrap #login .tip-wrap').hide();
    }
}

export function useABCC() {
    const isABCC = getQuery('fromService') === 'ABCC';
    if (isABCC) {
        $('.passport-account').click();
        $('#choose-uc-login').hide();
    }
}

/**
 * 判断是否在 App 中，如果在 App 中， 则直接调起原生的登录界面
 */
export function useIsInApp(fromUrl: string) {
    function loginSuccess() {
        window.location.replace(decodeURIComponent(getRedirectUrl(fromUrl)) + location.hash);
    }

    function loginFailure() {
        // 若用户进入 console 时，产品页面加载过后再跳转，则会在 history 中有两个记录，此时需要回退两步
        // 若 console 的产品页面是直接 302 重定向到登录页的，则没有 console 的 referrer，直接回退一步
        if (/(qasandbox|console)\.(bcetest|bce)\.baidu\.com/.exec(document.referrer)) {
            window.history.go(-2);
        } else {
            window.history.go(-1);
        }
    }

    function downloadAll(srcArr: string[]) {
        function down(src: string) {
            const el = document.createElement('script');
            el.src = src;
            document.head.appendChild(el);
        }
        for (const src of srcArr) {
            down(src);
        }
    }
    if (navigator.userAgent.includes('bai du yun')) {
        // 隐藏 body,避免闪烁
        window.addEventListener('DOMContentLoaded', () => {
            document.body.style.display = 'none';
        });

        if (navigator.userAgent.includes('Android')) {
            downloadAll(['/app/android/cordova.js', '/app/android/cordova_plugins.js']);
        }

        if (navigator.userAgent.includes('iOS')) {
            downloadAll(['/app/ios/cordova.js', '/app/ios/cordova_plugins.js']);
        }

        document.addEventListener('deviceready', () => {
            if (window.nativeAction) {
                window.nativeAction.showNativeLoginView('', loginSuccess, loginFailure);
            }
        });
    }
}

// 默认登录方式处理方法
export function useSwitchDefaultLoginType(options: any, channel?: Channel) {
    // passport登录成功后，会在localstorage里存一个passLoginType的key，value为sms或者normal
    // 如果不做任何处理，passport的sdk会默认选中passLoginType对应的登录方式
    // 下面的的逻辑是为了选中default_ui_login_type这个cookie对应的登录方式
    const loginType = getLoginType();
    if (loginType === LoginType.SMS_PASSPORT) {
        // http://passport.qatest.baidu.com/passApi/js/loginv5_tangram_4468608.js
        // passport sdk 内部方法，谨慎使用
        options.target._changeLoginType('sms');
        if (channel === 'wap') {
            $('.pass-foot-bar-forget-wrap').css('visibility', 'hidden');
        }
        monitor.trackBehavior({
            name: `百度智能云控制台-login-${channel}登录页-默认登录方式`,
            category: '默认登录方式',
            action: 'click',
            value: 'passport-sms-tab',
        });
    } else if (loginType === LoginType.NORMAL_PASSPORT) {
        options.target._changeLoginType('normal');
        monitor.trackBehavior({
            name: `百度智能云控制台-login-${channel}登录页-默认登录方式`,
            category: '默认登录方式',
            action: 'click',
            value: 'passport-normal-tab',
        });
    }
}

// UC JS SDK登录的特殊处理，登录成功后需要前端自己跳转
export function loginSuccessRedirect(fromu: string) {
    !fromu.includes(location.hash) && (fromu += location.hash);
    // ios某些版本（移动端）Safari 使用 location.href会失效
    const ua = navigator.userAgent.toLowerCase();
    if (
        ua.includes('applewebkit') &&
        ua.includes('mobile') &&
        ua.includes('safari') &&
        !ua.includes('linux') &&
        !ua.includes('android')
    ) {
        setTimeout(() => {
            document.location.href = fromu;
        }, 250);
    } else {
        location.href = fromu;
    }
}

export function renderError(error: string) {
    if (error) {
        const loginType = getLoginType();
        if (loginType === LoginType.UC) {
            $('#account-error').text(error).addClass('visible-show');
        } else {
            loginType === LoginType.NORMAL_PASSPORT
                ? $('.pass-form-normal .pass-generalError-error').text(error)
                : $('.tang-pass-sms .pass-generalError').text(error);
        }
    }
}

// https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/DDWA7rKjDG/ctFiYDJ-YO/30Hmnzo8YDHIJt
// 本地开发时调试UC登录图片验证码样式
export const showImageCaptcha = (appid: string | number) => {
    const tpl = [
        '<div class="token">',
        // eslint-disable-next-line
        '<input id="uc-common-token" type="text" placeholder="验证码" autocomplete="off" tabindex="3" maxlength="4" name="entered_imagecode" />',
        // eslint-disable-next-line
        '<img id="token-img" class="js-change-token" title="验证码" width="99" height="39" alt="验证码" src="https://cas.baidu.com?action=image2&appid=',
        appid,
        '" />',
        '<a href="javascript:void(0);" class="js-change-token">换一张</a>',
        '</div>',
        '<p id="token-error" class="error uc-token-error"></p>',
    ].join('');
    $('#uc-login .uc-login-token-wrap').html(tpl);
};

// https://console.cloud.baidu-int.com/devops/icafe/issue/BE-EOP-57244/show?source=copy-shortcut
export function handleCanceledAccount() {
    const search = getSearch(location.href);
    const cancel = getQueryVariable('cancel', search);
    if (cancel === '1') {
        toast.warning({
            message: '账号注销提示',
            description: '发起跳转的账号已在百度智能云注销，请登录其他账号或重新注册账号，完成后续业务流程',
        });
    }
}

export function changeUCPlaceholder() {
    $('#uc-common-account').attr('placeholder', '用户名（与百度营销、百度联盟等账号通用）');
    // UC登录框里的密码输入框也是异步动态生成的，所以也通过MutationObserver监听一下
    const targetNode = $('#uc-safe-pwd-input')[0];
    const config = {attributes: true, childList: true, subtree: true};
    const callback = (mutationList, observe) => {
        $('#ucsl-password-edit').attr('placeholder', '密码');
        // 这里disconnect，防止无限触发callback
        observe.disconnect();
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

export function changeUCError() {
    // UC登录框里的错误提示位置跟passport不统一
    // 统一将account-error中的错误信息覆盖到password-error中
    const targetNode = $('#account-error')[0];
    const config = {childList: true};
    const callback = () => {
        const accountError = $('#account-error').html();
        const passwordError = $('#password-error').html();
        if (accountError && !passwordError) {
            $('#password-error').html(accountError);
            $('#account-error').html('');
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

export function changePassPlaceholder() {
    $('.pass-text-input-smsPhone').attr('placeholder', '手机号');
    $('.pass-text-input-userName').attr('placeholder', '手机号/用户名/邮箱');
    $('.pass-text-input-password').attr('placeholder', '密码');
}

export function changePassLoginTypeOrder() {
    const $sms = $('.login-type-tab>.switch-item:contains("短信登录")');
    const $normal = $('.login-type-tab>.switch-item:contains("账号登录")');
    if ($sms.length && $normal.length) {
        $sms.after($normal);
    }
}

export const yinshangAccountList = [
    'b86fde24b7074b7eaedd1f8a11683380',
    '21d500eed6364bb1ab76c26303efaf77',
    '25d0265352b14257a0f35274ab52ac9c',
    '44327deb28ce43559eb778face225ab7',
    '44c8617bdcbc4ae79abac29eced663e3',
    '4f8401a707f64f4a9625fa2ad1ae98f7',
    '5b0c66e449f34b65a8ffbe9228104206',
    '6178f3d41a744b6d9be3e7440cc9b8a5',
    '8236cebb24c4450089b47790398ea154',
    '8a34d06c84ed4a6a9fc6c5ecd9993d3a',
    'a535b200be274961b70dea3c1d823496',
    'b80a990e9ba245d893e88d5cad9fa59f',
    'b90a8fa2cea647fea5054843a4819063',
    'c3d5117c06d843f582db287d0c675bc1',
    'd5d2945755444d9d99c99fa334cd605e',
    'e1a4a40cefb340e7a1a3a12e3e088791',
    'f5cd8d3b4b01402fb28d2962c98dbf51',
    '09bbc07da9144922b30c10f4e764cab8',
    '37fe86998b9046b880d10ddf5f16667d',
    '03b85955364b4342813b78651f77f095',
    '42f0b6d96bf64a059478bfa186ddef42',
];
export function replaceYinshangBrand(options: {$yinshangOrgAccount: 'true' | 'false'; account: string}) {
    const {$yinshangOrgAccount, account} = options;
    if (yinshangAccountList.includes(account) || $yinshangOrgAccount === 'true') {
        $('.logo-wrap').html(
            '<img height=26 src="https://bce.bdstatic.com/eop-plat/assets/img/login/yinshang-logo%402x.png" />'
        );
    }
}

export function changeAgreementPosition() {
    const normalAgreement = $('.pass-form-normal .tang-pass-sms-agreement');
    normalAgreement.find('label').text('我已阅读并同意');
    const smsAgreement = $('.tang-pass-sms .tang-pass-sms-agreement');
    smsAgreement.find('label').text('我已阅读并同意');
    const normalErrorWrapper = $('.pass-form-normal .pass-generalErrorWrapper');
    const smsErrorWrapper = $('.tang-pass-sms .pass-generalErrorWrapper');
    normalErrorWrapper.after(normalAgreement);
    smsErrorWrapper.after(smsAgreement);
}
